<template>
    <v-container>
        <v-alert dense outlined type="error" class="mt-4">
            <div class="text-h6">
                Naughty, Naughty. You do not have permission to access that {{ name }} resource. <br />The relevant
                authorities have been informed and the appropriate response teams are on the way
            </div>
            <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
            <div>
                If you feel this is a mistake, or require any assistance understanding why you do not have permission
                please contact the Administrators
            </div>
        </v-alert>
    </v-container>
</template>
<script>
export default {
    props: {
        name: String,
    },
}
</script>
